import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from '../../components/feature/HeroSection';
import TrustBar from '../../components/feature/TrustBar';
import ServicesGrid from '../../components/feature/ServicesGrid';
import MidPageCTA from '../../components/feature/MidPageCTA';
import AIBlock from '../../components/feature/AIBlock';
import ProcessTimeline from '../../components/feature/ProcessTimeline';
import WhyChooseUs from '../../components/feature/WhyChooseUs';
import ServiceAreaMap from '../../components/feature/ServiceAreaMap';
import TestimonialsSection from '../../components/feature/TestimonialsSection';
import FAQAccordion from '../../components/feature/FAQAccordion';
import FinalCTASection from '../../components/feature/FinalCTASection';

const heroData = {
  eyebrow: 'Solar Installation Experts — Jeffersonville, IN',
  headline: 'Power Your Home.',
  headlineAccent: 'Eliminate Your Bill.',
  subheadline:
    'Family-owned solar specialists serving Southern Indiana &amp; North Central Kentucky. Licensed, insured, and trusted since 2015.',
  primaryCTA: {
    label: 'Schedule Free Consultation',
    href: 'https://meetings.hubspot.com/starsolarspecialists/solarpowerconsultation',
    external: true,
  },
  secondaryCTA: {
    label: 'Call 812-913-0867',
    href: 'tel:+18129130867',
    external: false,
  },
  backgroundImage:
    'https://public.readdy.ai/ai/img_res/a21e3642090aa606cc031f246c4e425c.jpg',
};

const servicesData = {
  eyebrow: 'What We Install',
  headline: 'Solar Power Solutions for Every Property',
  subheadline: 'From single-family homes to commercial warehouses and nonprofits — we design and install custom solar systems built to perform in Kentuckiana\'s climate.',
  cards: [
    {
      title: 'Residential Solar',
      description:
        'Custom solar systems for homes of all sizes. Lower or eliminate your monthly electric bill and take advantage of the 30% federal tax credit available now.',
      image:
        'https://readdy.ai/api/search-image?query=beautiful%20modern%20american%20house%20with%20sleek%20solar%20panels%20installed%20on%20roof%20sunny%20day%20blue%20sky%20green%20lawn%20premium%20residential%20photography%20warm%20light%20curb%20appeal%20high%20quality&width=800&height=700&seq=svc-res01&orientation=portrait',
      href: '/services',
      badge: 'Save 30% — Federal Tax Credit',
      keyword: 'Residential Solar — Southern Indiana & Kentucky',
      features: ['30% Tax Credit', 'Custom Design', 'Battery Storage', 'Grid Tie-In'],
    },
    {
      title: 'Commercial Solar',
      description:
        'Solar installations for offices, warehouses, and businesses of any size — with up to 85% cost depreciation available in the first year.',
      image:
        'https://readdy.ai/api/search-image?query=large%20commercial%20building%20warehouse%20with%20solar%20panel%20array%20on%20flat%20roof%20industrial%20area%20blue%20sky%20sunny%20day%20professional%20photography%20aerial%20view&width=700&height=400&seq=svc-com01&orientation=landscape',
      href: '/services',
      keyword: 'Commercial Solar — Kentuckiana Businesses',
    },
    {
      title: 'Nonprofit Solar',
      description:
        'We help nonprofits and houses of worship reduce overhead costs with solar power, so more resources go directly toward your mission.',
      image:
        'https://readdy.ai/api/search-image?query=nonprofit%20community%20building%20church%20with%20solar%20panels%20on%20roof%20green%20trees%20sunny%20day%20suburban%20american%20street%20bright%20colors%20clean%20energy&width=700&height=400&seq=svc-np01&orientation=landscape',
      href: '/services',
      keyword: 'Nonprofit Solar — Indiana & Kentucky',
    },
  ],
};

const aiData = {
  eyebrow: 'About Star Solar Specialists',
  headline: 'Kentuckiana\'s Trusted Local Solar Installer',
  description:
    'Star Solar Specialists is a family-owned and operated solar installation company headquartered in Jeffersonville, Indiana. Licensed in both IN and KY, we\'ve been bringing affordable solar to homes, businesses, and nonprofits across the region since 2015.',
  pillars: [
    {
      icon: 'ri-home-gear-line',
      title: 'Residential Installations',
      description: 'Custom solar for homes of all sizes throughout Southern Indiana and North Central Kentucky.',
    },
    {
      icon: 'ri-building-2-line',
      title: 'Commercial Installations',
      description: 'From small offices to large warehouses — we design and install commercial solar for all business types.',
    },
    {
      icon: 'ri-heart-line',
      title: 'Nonprofit Solar',
      description: 'Helping mission-driven organizations reduce costs through solar, freeing resources for what matters most.',
    },
    {
      icon: 'ri-battery-charge-line',
      title: 'Battery Storage',
      description: 'Energy independence with battery backup systems — protect your home or business from grid outages.',
    },
  ],
};

const HomePage = () => (
  <main>
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'LocalBusiness',
          name: 'Star Solar Specialists',
          image: 'https://starsolarspecialists.com/wp-content/uploads/2020/04/Star-Solar-Logo-1.png',
          address: {
            '@type': 'PostalAddress',
            streetAddress: '509 Ohio Avenue',
            addressLocality: 'Jeffersonville',
            addressRegion: 'IN',
            postalCode: '47130',
            addressCountry: 'US',
          },
          telephone: '+18129130867',
          email: 'info@starsolarspecialists.com',
          url: 'https://starsolarspecialists.com',
          openingHoursSpecification: [
            {
              '@type': 'OpeningHoursSpecification',
              dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
              opens: '09:00',
              closes: '17:00',
            },
          ],
          areaServed: 'Southern Indiana and North Central Kentucky',
          priceRange: '$$',
        }),
      }}
    />
    <Navbar />
    <HeroSection data={heroData} />
    <TrustBar />
    <ServicesGrid {...servicesData} />
    <MidPageCTA />
    <AIBlock {...aiData} />
    <ProcessTimeline />
    <WhyChooseUs />
    <ServiceAreaMap />
    <TestimonialsSection />
    <FAQAccordion />
    <FinalCTASection />
    <Footer />
  </main>
);

export default HomePage;
